/**
 * PiSA sales Web Client
 * Copyright (c) 2021 PiSA sales GmbH
 */

import PISA_WebClientInit from './init';

// call global initialization function
PISA_WebClientInit(true);

// End Of File //
